<template>
  <div id="app" :class="{'safari': safari}">
    <router-view />
  </div>
</template>

<script>
export default {
  computed: {
    safari () {
      return this.$store.state.safari
    }
  }
}
</script>
<style lang="scss">
@import './map.css';
@import './global.scss';
</style>
